import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.269 4.269A1.034 1.034 0 1 1 12.73 5.73l-5.233 5.234H19a1.035 1.035 0 0 1 0 2.07H7.498l5.233 5.234a1.034 1.034 0 1 1-1.463 1.463l-7-7a1.034 1.034 0 0 1 0-1.463z"
}));
export default SvgArrowLeft;
//# sourceMappingURL=ArrowLeft.js.map